




































































































































import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase';
import { State, Action } from 'vuex-class';

import { GrowthCycleTemplate, Harvest, Raft } from '@/models/growth-cycle-template';

@Component
export default class GrowthCycleTemplatesComponent extends Vue {
    @State('growthCycleTemplates') private growthCycleTemplatesState: any;
    @State('raftTypes') private raftTypesState: any;
    @Action('getGrowthCycleTemplates') private getGrowthCycleTemplatesAction: any;
    @Action('addGrowthCycleTemplate') private addGrowthCycleTemplateAction: any;
    @Action('getRaftTypes') private getRaftTypesAction: any;

    private isAddVisible = false;

    private newTemplateFieldsReset = {
        name: '',
        cellCount: undefined,
        daysInGermination: undefined,
        daysInPropagation: undefined,
        daysInHighDensity: undefined,
        raftTypeHighDensity: 0,
        expectedHighDensityRafts: 0,
        expectedHighDensityCellsRemaining: 0,
        daysInFinishedSpacing: undefined,
        raftTypeFinishedSpacing: 0,
        expectedFinishedSpacingRafts: 0,
        expectedFinishedSpacingCellsRemaining: 0,
        harvestType: '',
        harvestInterval: 0,
        notes: '',
    };

    private newTemplateFields = this.newTemplateFieldsReset;

    private headers = [
        {
            text: 'Name',
            value: 'name',
            align: 'center',
        },
        {
            text: 'Cell Count',
            value: 'cellCount',
            align: 'center',
        },
        {
            text: 'Days in Germ.',
            value: 'daysInGermination',
            align: 'center',
        },
        {
            text: 'Days in Prop.',
            value: 'daysInPropagation',
            align: 'center',
        },
        {
            text: 'Days in HD',
            value: 'daysInHighDensity',
            align: 'center',
        },
        {
            text: 'Days in FS',
            value: 'daysInFinishedSpacing',
            align: 'center',
        },
        {
            text: 'Harvest Type',
            value: 'harvestType',
            align: 'center',
        },
    ];

    private harvestTypes = [
        {
            text: 'Once',
            value: Harvest.Once,
        },
        {
            text: 'Multiple',
            value: Harvest.Many,
        },
    ];

    private raftTypes: Array<{text: string, value: number}> = [];

    private created(): void {
        this.getGrowthCycleTemplatesAction();
        this.getRaftTypesAction();

        this.$store.watch(
            (state) => {
                return this.$store.state.raftTypes;
            },
            (newVal: Raft[]) => {
                newVal.map((raft: Raft) => {
                    this.raftTypes.push({
                        text: raft.cellSpacing.toString(),
                        value: raft.cellSpacing,
                    });
                });
            },
        );
    }

    private submit(): void {
        this.addGrowthCycleTemplateAction(this.newTemplateFields);
        this.newTemplateFields = this.newTemplateFieldsReset;
        this.toggleAdd();
    }

    private navigateToTemplate(id: string): void {
        this.$router.replace('/growth_cycles/templates/' + id);
    }

    private toggleAdd(): void {
        this.isAddVisible = !this.isAddVisible;
    }

    private updateExpectedAndRemainder(): void {
        if (this.newTemplateFields.cellCount) {
            const highDensityRafts =
                this.calculateRaftsAndRemainder(
                    this.newTemplateFields.cellCount!!,
                    this.newTemplateFields.raftTypeHighDensity);
            this.newTemplateFields.expectedHighDensityRafts = highDensityRafts.rafts;
            this.newTemplateFields.expectedHighDensityCellsRemaining = highDensityRafts.remainder;
        }
        if (this.newTemplateFields.raftTypeFinishedSpacing > 0 && this.newTemplateFields.cellCount) {
            const finishedSpacingRafts =
                this.calculateRaftsAndRemainder(
                    this.newTemplateFields.cellCount!!,
                    this.newTemplateFields.raftTypeFinishedSpacing);
            this.newTemplateFields.expectedFinishedSpacingRafts =
                finishedSpacingRafts.rafts;
            this.newTemplateFields.expectedFinishedSpacingCellsRemaining =
                finishedSpacingRafts.remainder;
        }
    }

    private calculateRaftsAndRemainder(cellCount: number, raftType: number):
        {rafts: number, remainder: number} {
            const rafts = Math.floor(cellCount / raftType);
            const remainder = cellCount % raftType;

            return {rafts, remainder};
    }
}
